// tslint:disable
import axios from 'axios';
import { cloneDeep, each, get } from 'lodash';
import { Subject } from 'rxjs/Subject';
import { Environment } from '../../../environment/environment';
import { Notification } from '../../../index';
import { FormLib } from '../form.lib';
//const alertify = require('alertifyjs');

export class DefaultSave<T> {
    public form: FormLib | null;
    public props: T | any;
    public endPoint: string;
    public redirectOnSave: boolean = true;
    public loading$: Subject<any> = new Subject();

    constructor(form: FormLib | null, props: any) {
        this.form = form;
        this.props = cloneDeep(props);
        this.endPoint = this.props.ENTITY;
    }

    public setEntityId(id: number | string) {
        this.props.ENTITY_ID = id;
    }

    public setCreate() {
        this.props.IS_CREATE = true;
        this.props.IS_UPDATE = false;
    }

    public setUpdate() {
        this.props.IS_CREATE = false;
        this.props.IS_UPDATE = true;
    }

    public setRedirectOnSave(bool: boolean) {
        this.redirectOnSave = bool;
    }

    public updateForm(form: FormLib) {
        this.form = form;
    }

    public updateEndPoint(value: any) {
        this.endPoint = value;
    }

    public async exec(redirectPath?: string | null, successMessage?: string): Promise<any> {
        try {
            if (this.form && !(await this.form.isValid())) {
                return;
            }

            this.loading$.next(true);

            if (this.form && this.props.IS_CREATE) {
                const rebased = this.form.toJS(false);

                each(rebased, (item: any, key: string) => {
                    if (item === null || (typeof item === 'undefined')) {
                        delete rebased[key];
                    }
                });

                const response = await axios.post(`${Environment.get('api.base')}/${this.endPoint}`, rebased, {withCredentials: true});
                this.props.ON_CREATE_SUCCESSFUL(response.data);

                if (!this.props.IS_MODAL && this.redirectOnSave) {
                    if (redirectPath) {
                        window.location.href = `/${redirectPath}/${get(response.data, 'id')}`;
                    } else {
                        window.location.href = get(response.data, '@id');
                    }

                }

                this.loading$.next(false);


                Notification.successSave(successMessage);
                return response.data;
            }

            if (this.form && this.props.IS_UPDATE) {
                const response = await axios.put(`${Environment.get('api.base')}/${this.endPoint}/${this.props.ENTITY_ID}`, this.form.toJS(true), {withCredentials: true});
                this.props.ON_UPDATE_SUCCESSFUL(response.data);
                this.loading$.next(false);
                Notification.successSave(successMessage);
                return response.data;
            }
        } catch (err) {
            this.loading$.next(false);
            const error = get(err, 'response.data[hydra:description]', null) || err.message;
            Notification.errorExec(error);
            //alertify.notify(error, 'error', 5);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/libs/updaters/default-save.tsx